let url = new Object()
const name = `events`

const common = `/api/${name}/`
url.common = {
}

const adminUrl = `/api/${name}/admin/`
url.admin = {
  getAll: `${adminUrl}getall`,
  getOne: `${adminUrl}getOne`,
  add: `${adminUrl}add`,
  update: `${adminUrl}update`,
  delete: `${adminUrl}delete`,
  setUser: `${adminUrl}user/set`,
  setGroup: `${adminUrl}group/set`,
  count: `${adminUrl}count`
}

// const dealerUrl = `/api/${name}/dealer/`;
// url.dealer = {
//     getAll: `${dealerUrl}getall`,
//     getOne: `${dealerUrl}getOne`,
//     add: `${dealerUrl}add`,
//     close:  `${dealerUrl}close`
// };

// module.exports = url;
export default url
